module.exports = __webpack_public_path__ + "assets/img/W-2-F.85055004.png";